import { isProd } from "@/config/common";
import {
  ContentfulLocaleEnum,
  CountryCodeEnum,
  CountryNameEnum,
  CurrencyCodeEnum,
  DomainEnum,
  ElevateCodeEnum,
  LanguageCodeEnum,
  type Market,
  PSPEnum,
  SiteLocaleEnum,
  SiteNameEnum,
} from "./i18n-config";

export const nl: Market = {
  psp: PSPEnum.ADYEN,
  flag: "🇳🇱",
  currency: CurrencyCodeEnum.EUR,
  countryCode: CountryCodeEnum.NL,
  countryName: CountryNameEnum.NL,
  languageCode: LanguageCodeEnum.NL,
  locale: `${LanguageCodeEnum.NL}-${CountryCodeEnum.NL}`,
  upperCaseLocale: `${LanguageCodeEnum.NL}-${CountryCodeEnum.NL.toUpperCase()}`,
  contentfulLocale: ContentfulLocaleEnum.NL,
  siteLocale: SiteLocaleEnum.NL,
  elevateMarket: ElevateCodeEnum.NL,
  externalStoreId: "ecom-nl",
  searchPathName: "/zoeken",
  domain: DomainEnum.NOGA,
  imageCdn: isProd()
    ? "https://cdn.no-ga.com"
    : "https://media.stage.cdn-norce.tech/1413",
  siteName: SiteNameEnum.NL,
};
